import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './components/MuiStyles';
import LandingPage from './components/LandingPage';
// import BookPage from './saved-for-later/BookPage';
// import FinalizePage from './saved-for-later/FinalizePage';
import ErrorLanding from './components/ErrorLanding';

function App() {
  const [error, setError] = useState(null);

  if (error) {
    return (
      <ThemeProvider theme={theme}>
        <ErrorLanding error={error} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            {/* <Route path="/book" element={<BookPage />} /> */}
            {/* <Route path="/finalize" element={<FinalizePage />} /> */}
            <Route path="*" element={<ErrorLanding error={{ message: "Page not found" }} />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
